export default "__VITE_ASSET__CSwoM$js__"